// import AngleTool from './AngleTool.js';
// import ArrowAnnotateTool from './ArrowAnnotateTool.js';
// import BidirectionalTool from './BidirectionalTool.js';
// import CircleRoiTool from './CircleRoiTool.js';
// import CobbAngleTool from './CobbAngleTool.js';
import EllipticalRoiTool from './EllipticalRoiTool.js';
import FreehandRoiTool from './FreehandRoiTool.js';
// import LengthTool from './LengthTool.js';
// import ProbeTool from './ProbeTool.js';
import RectangleRoiTool from './RectangleRoiTool.js';
// import TextMarkerTool from './TextMarkerTool.js';

// /**
//  * RXTO
//  */
// import AtelectasiaTool from './RXTO/AtelectasiaTool.js';
// import CardiomegaliaTool from './RXTO/CardiomegaliaTool.js';
// import CongestivoOrEdemaTool from './RXTO/CongestivoOrEdemaTool.js';
// import DestaqueHilarTool from './RXTO/DestaqueHilarTool.js';
// import DispositivosMedicosTool from './RXTO/DispositivosMedicosTool.js';
// import EfusaoTool from './RXTO/EfusaoTool.js';
// import FracturaTool from './RXTO/FracturaTool.js';
// import LesaoPulmonarTool from './RXTO/LesaoPulmonarTool.js';
// import MediastinoAmpliadoTool from './RXTO/MediastinoAmpliadoTool.js';
// import OpacidadePulmonarTool from './RXTO/OpacidadePulmonarTool.js';
// import OutrosAndSpecifyTool from './RXTO/OutrosAndSpecifyTool.js';
// import PleuralOutroTool from './RXTO/PleuralOutroTool.js';
// import PneumoniaOrConsolidacaoTool from './RXTO/PneumoniaOrConsolidacaoTool.js';
// import PneumotoraxTool from './RXTO/PneumotoraxTool.js';
// /**
//  * CITO
//  */
// import AdenocarcinomaInvasorTool from './CITO/AdenocarcinomaInvasorTool.js';
// import AisTool from './CITO/AisTool.js';
// import AscHTool from './CITO/AscHTool.js';
// import AscUsTool from './CITO/AscUsTool.js';
// import CelulaGrandularNormalTool from './CITO/CelulaGrandularNormalTool.js';
// import CelulaPavimentosaNormalTool from './CITO/CelulaPavimentosaNormalTool.js';
// import CgafnTool from './CITO/CgafnTool.js';
// import CgaTool from './CITO/CgaTool.js';
// import CpcTool from './CITO/CpcTool.js';
// import HsilTool from './CITO/HsilTool.js';
// import LsilTool from './CITO/LsilTool.js';
// import ZonaTransformacaoTool from './CITO/ZonaTransformacaoTool.js';
//
// /**
//  * COLP
//  */
// import IodonegativoTool from './COLP/IodonegativoTool.js';
// import PadroesMosaicoTool from './COLP/PadroesMosaicoTool.js';
// import PontuacoesTool from './COLP/PontuacoesTool.js';
// import RegioesAcetowhiteTool from './COLP/RegioesAcetowhiteTool.js';
// import VascularizacaoAnormalTool from './COLP/VascularizacaoAnormalTool.js';
// /**
//  * GLAU
//  */
// import AtrofiaTool from './GLAU/AtrofiaTool.js';
// import CopoOticoTool from './GLAU/CopoOticoTool.js';
// import DiscoOticoTool from './GLAU/DiscoOticoTool.js';
// import NervoOticoTool from './GLAU/NervoOticoTool.js';
// import TesteGlaucomaTool from './GLAU/TesteGlaucomaTool.js';
//
// /**
//  * OTHER
//  */
// import DefaultTool from './DefaultTool.js';

// Named Exports
// export { default as AngleTool } from './AngleTool.js';
// export { default as ArrowAnnotateTool } from './ArrowAnnotateTool.js';
// export { default as BidirectionalTool } from './BidirectionalTool.js';
// export { default as CircleRoiTool } from './CircleRoiTool.js';
// export { default as CobbAngleTool } from './CobbAngleTool.js';
export { default as EllipticalRoiTool } from './EllipticalRoiTool.js';
export { default as FreehandRoiTool } from './FreehandRoiTool.js';
// export { default as LengthTool } from './LengthTool.js';
// export { default as ProbeTool } from './ProbeTool.js';
export { default as RectangleRoiTool } from './RectangleRoiTool.js';
// export { default as TextMarkerTool } from './TextMarkerTool.js';
// /**
//  * RXTO
//  */
// export { default as AtelectasiaTool } from './RXTO/AtelectasiaTool.js';
// export { default as CardiomegaliaTool } from './RXTO/CardiomegaliaTool.js';
// export {
//   default as CongestivoOrEdemaTool,
// } from './RXTO/CongestivoOrEdemaTool.js';
// export { default as DestaqueHilarTool } from './RXTO/DestaqueHilarTool.js';
// export {
//   default as DispositivosMedicosTool,
// } from './RXTO/DispositivosMedicosTool.js';
// export { default as EfusaoTool } from './RXTO/EfusaoTool.js';
// export { default as FracturaTool } from './RXTO/FracturaTool.js';
// export { default as LesaoPulmonarTool } from './RXTO/LesaoPulmonarTool.js';
// export {
//   default as MediastinoAmpliadoTool,
// } from './RXTO/MediastinoAmpliadoTool.js';
// export {
//   default as OpacidadePulmonarTool,
// } from './RXTO/OpacidadePulmonarTool.js';
// export {
//   default as OutrosAndSpecifyTool,
// } from './RXTO/OutrosAndSpecifyTool.js';
// export { default as PleuralOutroTool } from './RXTO/PleuralOutroTool.js';
// export {
//   default as PneumoniaOrConsolidacaoTool,
// } from './RXTO/PneumoniaOrConsolidacaoTool.js';
// export { default as PneumotoraxTool } from './RXTO/PneumotoraxTool.js';
// /**
//  * CITO
//  */
// export {
//   default as AdenocarcinomaInvasorTool,
// } from './CITO/AdenocarcinomaInvasorTool.js';
// export { default as AisTool } from './CITO/AisTool.js';
// export { default as AscHTool } from './CITO/AscHTool.js';
// export { default as AscUsTool } from './CITO/AscUsTool.js';
// export {
//   default as CelulaGrandularNormalTool,
// } from './CITO/CelulaGrandularNormalTool.js';
// export {
//   default as CelulaPavimentosaNormalTool,
// } from './CITO/CelulaPavimentosaNormalTool.js';
// export { default as CgafnTool } from './CITO/CgafnTool.js';
// export { default as CgaTool } from './CITO/CgaTool.js';
// export { default as CpcTool } from './CITO/CpcTool.js';
// export { default as HsilTool } from './CITO/HsilTool.js';
// export { default as LsilTool } from './CITO/LsilTool.js';
// export {
//   default as ZonaTransformacaoTool,
// } from './CITO/ZonaTransformacaoTool.js';
// /**
//  * COLP
//  */
// export { default as IodonegativoTool } from './COLP/IodonegativoTool.js';
// export { default as PadroesMosaicoTool } from './COLP/PadroesMosaicoTool.js';
// export { default as PontuacoesTool } from './COLP/PontuacoesTool.js';
// export {
//   default as RegioesAcetowhiteTool,
// } from './COLP/RegioesAcetowhiteTool.js';
// export {
//   default as VascularizacaoAnormalTool,
// } from './COLP/VascularizacaoAnormalTool.js';
// /**
//  * GLAU
//  */
// export { default as AtrofiaTool } from './GLAU/AtrofiaTool.js';
// export { default as CopoOticoTool } from './GLAU/CopoOticoTool.js';
// export { default as DiscoOticoTool } from './GLAU/DiscoOticoTool.js';
// export { default as NervoOticoTool } from './GLAU/NervoOticoTool.js';
// export { default as TesteGlaucomaTool } from './GLAU/TesteGlaucomaTool.js';
// /**
//  * OTHER
//  */
// export { default as DefaultTool } from './DefaultTool.js';

// Namespace, default export
export default {
  // AngleTool,
  // ArrowAnnotateTool,
  // BidirectionalTool,
  // CircleRoiTool,
  // CobbAngleTool,
  EllipticalRoiTool,
  FreehandRoiTool,
  // LengthTool,
  // ProbeTool,
  RectangleRoiTool,
  // TextMarkerTool,
  // /*
  // RXTO
  //  */
  // AtelectasiaTool,
  // CardiomegaliaTool,
  // CongestivoOrEdemaTool,
  // DestaqueHilarTool,
  // DispositivosMedicosTool,
  // EfusaoTool,
  // FracturaTool,
  // LesaoPulmonarTool,
  // MediastinoAmpliadoTool,
  // OpacidadePulmonarTool,
  // OutrosAndSpecifyTool,
  // PleuralOutroTool,
  // PneumoniaOrConsolidacaoTool,
  // PneumotoraxTool,
  // /**
  //  * CITO
  //  */
  // AdenocarcinomaInvasorTool,
  // AisTool,
  // AscHTool,
  // AscUsTool,
  // CelulaGrandularNormalTool,
  // CelulaPavimentosaNormalTool,
  // CgafnTool,
  // CgaTool,
  // CpcTool,
  // HsilTool,
  // LsilTool,
  // ZonaTransformacaoTool,
  // /**
  //  * COLP
  //  */
  // IodonegativoTool,
  // PadroesMosaicoTool,
  // PontuacoesTool,
  // RegioesAcetowhiteTool,
  // VascularizacaoAnormalTool,
  // /**
  //  * GLAU
  //  */
  // AtrofiaTool,
  // CopoOticoTool,
  // DiscoOticoTool,
  // NervoOticoTool,
  // TesteGlaucomaTool,
  // /**
  //  * OTHER
  //  */
  // DefaultTool,
};
